<div class="hidden lg:block">
  <router-outlet />
</div>

<div class="fixed z-9999 flex h-screen w-screen grow lg:hidden">
  <app-information-screen [information]="responsiveScreenInformation" />
</div>

<p-confirm-dialog styleClass="w-96" />
<p-toast preventOpenDuplicates position="bottom-center" />
